import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { HomeTypesFailure, HomeTypesRequest, HomeTypesSuccess } from './actions';
import { ParameterResult } from '@models/swagger';

export const featureKey = 'homeTypes';

export interface State {
  data: ParameterResult[] | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: [],
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(HomeTypesFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(HomeTypesRequest, state => ({ ...state, error: null, loading: true })),
    on(HomeTypesSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
